const NAV_ROLE_CACHE_KEY = "tk.nav.role";
export type CompanyRole = "employee" | "manager" | "admin" | string;

export function canUseControlPanel(role: CompanyRole | null | undefined) {
  return role === "admin" || role === "manager";
}

export function loadCachedRole(): CompanyRole | null {
  try {
    return (localStorage.getItem(NAV_ROLE_CACHE_KEY) as CompanyRole) ?? null;
  } catch {
    return null;
  }
}

export function saveCachedRole(role: CompanyRole) {
  try {
    localStorage.setItem(NAV_ROLE_CACHE_KEY, role);
  } catch {}
}
